// @ts-check

// import Cookies from 'js-cookie'
// import { COOKIES_ALLOWED_KEY } from '@/lib/api.model'
// @ts-ignore
import Config from '@/config'
import {
	API_BASE_URL,
// @ts-ignore
} from '@/lib/api.model'

/**
 * @returns {Promise<string>}
 */
export const blobToBase64 = blob => {
	const reader = new FileReader()
	reader.readAsDataURL(blob)

	return new Promise((resolve, reject) => {
		reader.onerror = (err) => {
			reject(err)
		}
		reader.onloadend = () => {
			resolve(reader.result)
		}
	})
}

export const cookiesEnabled = () => {
	// return import.meta.env.DEV || Cookies.get(COOKIES_ALLOWED_KEY) === '1'
	return true
}

export const hasChanged = (a, b, properties = []) => {
	return properties.some(prop => !Object.is(a[prop], b[prop]))
}

export const wait = (timeout, value = null) => {
	return new Promise(resolve => {
		const tid = setTimeout(() => {
			resolve(value)
			clearTimeout(tid)
		}, timeout);
	})
}

export const throwForbiddenAction = () => {
	const err = new Error('Forbidden action.')
	err['code'] = 'FORBIDDEN_CLIENT_ACTION'
	throw err
}

export const logError = (...args) => {
	Config.isLoggingEnabled && console.error(...args)
}

export const logAndRethrow = error => {
	logError(error)
	throw error
}

export const UI_EMAIL_MAX_LENGTH = 30
export const UI_EMAIL_OVERFLOW_PLACEHOLDER = '***'

export const minifyEmail = (
	value,
	maxLength = UI_EMAIL_MAX_LENGTH,
	placeholder = UI_EMAIL_OVERFLOW_PLACEHOLDER
) => {
	if (value.length <= maxLength) return value

	const cutSize = Math.abs(value.length - maxLength)
	const [ id, domain ] = value.split('@')
	const shortenedId = id.slice(0, id.length - cutSize - placeholder.length)
	return shortenedId + placeholder + '@' + domain
}

export const getAvatarUrl = (avatarId) => {
	return `${ API_BASE_URL }/file/${ avatarId }`
}

/**
 * @param {Promise<any>} promise
 * @returns {Promise<[any, any]>}
 */
export const asyncWrap = async (promise) => {
	try {
		const data = await promise
		return [data, null]
	} catch (err) {
		return [null, err]
	}
}

// escs-oauth-client/src/lib/util.js
export const isNativeFlowFromUrl = () => {
	try {
	  const search = typeof window !== 'undefined' ? window.location.search : ''
	  if (!search) return false

	  const qs = new URLSearchParams(search)

	  // Prefer provider callback "state" if present
	  const rawState = qs.get('state')
	  if (rawState && rawState.trim()) {
			try {
				const parsed = JSON.parse(rawState)
				const p = parsed?.escs_oauth ?? {}
				const protocol = typeof p.protocol === 'string' ? p.protocol : ''
				const origin = (p.originPlatform ?? p.origin_platform) || ''
				if (origin === 'native' || protocol.startsWith('escs-external-')) return true
			} catch {}
	  }

	  // Fallback for /oauth entry
	  const protocol = (qs.get('protocol') ?? '')
	  const origin = (qs.get('origin_platform') ?? qs.get('originPlatform') ?? '')
	  return origin === 'native' || protocol.startsWith('escs-external-')
	} catch {
	  return false
	}
}

export const isTablet = () => {
	if (typeof navigator === 'undefined') return false
	const ua = navigator.userAgent || ''

	// iPad (incl. older iPads)
	if (/iPad/.test(ua)) return true

	// Android tablets often don't include "Mobile" in UA
	if (/Android/.test(ua) && !/Mobile/.test(ua)) return true

	// Common tablet identifiers
	if (/Tablet|PlayBook|Silk/.test(ua)) return true

	// iPadOS detection: reports MacIntel but has touch points
	if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) return true

	return false
}

export const isMobilePhone = () => {
	if (typeof navigator === 'undefined') return false
	const ua = navigator.userAgent || ''

	// iPhone
	if (/iPhone/.test(ua)) return true

	// Android phones usually include "Mobile"
	if (/Android/.test(ua) && /Mobile/.test(ua)) return true

	// Windows Phone / older mobile identifiers
	if (/Windows Phone|IEMobile|WPDesktop/.test(ua)) return true

	// If UA Client Hints available, use the mobile hint but exclude tablets
	if (navigator.userAgentData && typeof navigator.userAgentData.mobile === 'boolean') {
		return navigator.userAgentData.mobile && !isTablet()
	}

	// Fallback: touch device + narrow viewport likely a phone
	if (typeof window !== 'undefined' && 'maxTouchPoints' in navigator && navigator.maxTouchPoints > 0) {
		return window.innerWidth <= 820 && !isTablet()
	}

	return false
}

export const isMobileOrTablet = () => {
	return isMobilePhone() || isTablet()
}
